export default async (_, inject) => {
  inject('pref', {
    codes: {
      "1": {
        "code": "1",
        "name": "北海道",
        "stem": "北海",
        "suffix": "道"
      },
      "2": {
        "code": "2",
        "name": "青森県",
        "stem": "青森",
        "suffix": "県"
      },
      "3": {
        "code": "3",
        "name": "岩手県",
        "stem": "岩手",
        "suffix": "県"
      },
      "4": {
        "code": "4",
        "name": "宮城県",
        "stem": "宮城",
        "suffix": "県"
      },
      "5": {
        "code": "5",
        "name": "秋田県",
        "stem": "秋田",
        "suffix": "県"
      },
      "6": {
        "code": "6",
        "name": "山形県",
        "stem": "山形",
        "suffix": "県"
      },
      "7": {
        "code": "7",
        "name": "福島県",
        "stem": "福島",
        "suffix": "県"
      },
      "8": {
        "code": "8",
        "name": "茨城県",
        "stem": "茨城",
        "suffix": "県"
      },
      "9": {
        "code": "9",
        "name": "栃木県",
        "stem": "栃木",
        "suffix": "県"
      },
      "10": {
        "code": "10",
        "name": "群馬県",
        "stem": "群馬",
        "suffix": "県"
      },
      "11": {
        "code": "11",
        "name": "埼玉県",
        "stem": "埼玉",
        "suffix": "県"
      },
      "12": {
        "code": "12",
        "name": "千葉県",
        "stem": "千葉",
        "suffix": "県"
      },
      "13": {
        "code": "13",
        "name": "東京都",
        "stem": "東京",
        "suffix": "都"
      },
      "14": {
        "code": "14",
        "name": "神奈川県",
        "stem": "神奈川",
        "suffix": "県"
      },
      "15": {
        "code": "15",
        "name": "新潟県",
        "stem": "新潟",
        "suffix": "県"
      },
      "16": {
        "code": "16",
        "name": "富山県",
        "stem": "富山",
        "suffix": "県"
      },
      "17": {
        "code": "17",
        "name": "石川県",
        "stem": "石川",
        "suffix": "県"
      },
      "18": {
        "code": "18",
        "name": "福井県",
        "stem": "福井",
        "suffix": "県"
      },
      "19": {
        "code": "19",
        "name": "山梨県",
        "stem": "山梨",
        "suffix": "県"
      },
      "20": {
        "code": "20",
        "name": "長野県",
        "stem": "長野",
        "suffix": "県"
      },
      "21": {
        "code": "21",
        "name": "岐阜県",
        "stem": "岐阜",
        "suffix": "県"
      },
      "22": {
        "code": "22",
        "name": "静岡県",
        "stem": "静岡",
        "suffix": "県"
      },
      "23": {
        "code": "23",
        "name": "愛知県",
        "stem": "愛知",
        "suffix": "県"
      },
      "24": {
        "code": "24",
        "name": "三重県",
        "stem": "三重",
        "suffix": "県"
      },
      "25": {
        "code": "25",
        "name": "滋賀県",
        "stem": "滋賀",
        "suffix": "県"
      },
      "26": {
        "code": "26",
        "name": "京都府",
        "stem": "京",
        "suffix": "都"
      },
      "27": {
        "code": "27",
        "name": "大阪府",
        "stem": "大阪",
        "suffix": "府"
      },
      "28": {
        "code": "28",
        "name": "兵庫県",
        "stem": "兵庫",
        "suffix": "県"
      },
      "29": {
        "code": "29",
        "name": "奈良県",
        "stem": "奈良",
        "suffix": "県"
      },
      "30": {
        "code": "30",
        "name": "和歌山県",
        "stem": "和歌山",
        "suffix": "県"
      },
      "31": {
        "code": "31",
        "name": "鳥取県",
        "stem": "鳥取",
        "suffix": "県"
      },
      "32": {
        "code": "32",
        "name": "島根県",
        "stem": "島根",
        "suffix": "県"
      },
      "33": {
        "code": "33",
        "name": "岡山県",
        "stem": "岡山",
        "suffix": "県"
      },
      "34": {
        "code": "34",
        "name": "広島県",
        "stem": "広島",
        "suffix": "県"
      },
      "35": {
        "code": "35",
        "name": "山口県",
        "stem": "山口",
        "suffix": "県"
      },
      "36": {
        "code": "36",
        "name": "徳島県",
        "stem": "徳島",
        "suffix": "県"
      },
      "37": {
        "code": "37",
        "name": "香川県",
        "stem": "香川",
        "suffix": "県"
      },
      "38": {
        "code": "38",
        "name": "愛媛県",
        "stem": "愛媛",
        "suffix": "県"
      },
      "39": {
        "code": "39",
        "name": "高知県",
        "stem": "高知",
        "suffix": "県"
      },
      "40": {
        "code": "40",
        "name": "福岡県",
        "stem": "福岡",
        "suffix": "県"
      },
      "41": {
        "code": "41",
        "name": "佐賀県",
        "stem": "佐賀",
        "suffix": "県"
      },
      "42": {
        "code": "42",
        "name": "長崎県",
        "stem": "長崎",
        "suffix": "県"
      },
      "43": {
        "code": "43",
        "name": "熊本県",
        "stem": "熊本",
        "suffix": "県"
      },
      "44": {
        "code": "44",
        "name": "大分県",
        "stem": "大分",
        "suffix": "県"
      },
      "45": {
        "code": "45",
        "name": "宮崎県",
        "stem": "宮崎",
        "suffix": "県"
      },
      "46": {
        "code": "46",
        "name": "鹿児島県",
        "stem": "鹿児島",
        "suffix": "県"
      },
      "47": {
        "code": "47",
        "name": "沖縄県",
        "stem": "沖縄",
        "suffix": "県"
      }
    },
    groups: {
      1: {
        name: '北海道',
        targets: [...Array(1).keys()].map(x => (x + 1).toString())
      },
      2: {
        name: '東北',
        targets: [...Array(6).keys()].map(x => (x + 2).toString())
      },
      3: {
        name: '関東',
        targets: [...Array(7).keys()].map(x => (x + 8).toString())
      },
      4: {
        name: '中部',
        targets: [...Array(10).keys()].map(x => (x + 15).toString())
      },
      5: {
        name: '関西',
        targets: [...Array(6).keys()].map(x => (x + 25).toString())
      },
      6: {
        name: '中国・四国',
        targets: [...Array(9).keys()].map(x => (x + 31).toString())
      },
      7: {
        name: '九州・沖縄',
        targets: [...Array(8).keys()].map(x => (x + 40).toString())
      }
    }
  })
}
